/* eslint-disable max-lines */
import {
  useI18n,
  TypeIcon,
  LivingSpaceIcon,
  PieceIcon,
  ConstructionYearIcon,
  ConfigurationIcon,
} from '@popety_io/popety-io-lib'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'

const ListingDetails = ({ listing }: { listing: any }) => {
  const { t } = useI18n()

  const data1 = [
    {
      label: t('listing.propertyCategory'),
      name: 'type',
      value:
        `${t(`listing.property_type.${listing.property_type}`)}` ||
        `${t(`listing.property_category.${listing.property_category}`)}`,
      icon: (
        <TypeIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('listing.Surface habitable'),
      name: 'area',
      value: listing.area || '-',
      endAdornment: 'm²',
      icon: (
        <LivingSpaceIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
  ]

  const data2 = [
    {
      label: t('listing.Salles de bain'),
      value: listing?.bathroom_nb > 0 ? listing?.bathroom_nb : '-',
      icon: (
        <PieceIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
    {
      label: t('listing.Année de constr'),
      name: 'buildingYear',
      value: listing.YearOfConstruction || '-',
      endAdornment: '',
      icon: (
        <ConstructionYearIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
  ]

  const data3 = [
    {
      label: t('building.Etage'),
      name: 'etage',
      value: listing.Floor || '-',
      endAdornment: '',
      icon: (
        <ConfigurationIcon
          sx={{
            fontSize: '1.4rem',
          }}
        />
      ),
    },
  ]

  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: '1.1rem',
          fontWeight: 500,
          textTransform: 'uppercase',
          mb: 1,
        }}
      >
        {t('fao.details')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          {data1.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '4px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      color: '#969696',
                      fontSize: '0.9rem',
                    }}
                  >
                    {item.icon}
                    <Typography
                      fontWeight="500"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={6}>
                  <Typography
                    fontWeight="500"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {item.value}
                    {item.value !== '-' ? item?.endAdornment : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {data2.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '4px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      color: '#969696',
                      fontSize: '0.9rem',
                    }}
                  >
                    {item.icon}
                    <Typography
                      fontWeight="500"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={6}>
                  <Typography
                    fontWeight="500"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {item.value}
                    {item.value !== '-' ? item?.endAdornment : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {data3.map((item, i) => (
            <Box
              key={i}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '4px',
              }}
            >
              <Grid container spacing={2}>
                <Grid item sm={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '10px',
                      color: '#969696',
                      fontSize: '0.9rem',
                    }}
                  >
                    {item.icon}
                    <Typography
                      fontWeight="500"
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '1',
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item sm={6}>
                  <Typography
                    fontWeight="500"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '1',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {item.value}
                    {item.value !== '-' ? item?.endAdornment : ''}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ListingDetails
